import React from 'react';
import { siteLinks } from '@agria/theme/src/const/siteLinks';
import { ButtonProps } from '@agria/theme/src/components/button';

//
// CUSTOMERS
//

const customerCtaOverride: ButtonProps = {
  label: 'Add another pet',
  url: siteLinks.quoteAndBuy,
  arrowRight: true,
};

export const ctaButtons = {
  customer: customerCtaOverride,
};
